export enum AuthFormStep {
  EMAIL = 1,
  LOGIN = 2,
  REGISTRATION = 3,
  PASSWORD_FORGOTTEN = 4,
}

export enum AuthFormLocation {
  POPOVER,
  CHECKOUT,
  RETURN_PORTAL,
  LOGIN,
  LOGIN_FLOWS,
  CHECKOUT_V2,
}

export enum AuthStatusCode {
  // No account
  NO_ACCOUNT = 0,
  // Valid account
  VALID_ACCOUNT = 200,
  // Invalid credentials
  INVALID_PASSWORD = 401,
  // No account
  UNKNOWN_ACCOUNT = 404,
  // Account on same fascia but no password
  INVALID_ACCOUNT = 666,
  // Account on friendly fascia
  VALID_ACCOUNT_OTHER_FASCIA = 664,
  // Account on friendly fascia but no password
  INVALID_ACCOUNT_OTHER_FASCIA = 665,
}
